/**
 * documentation at
 * https://webartelier.de/fee_doc/list_classes.html#dialog
 */


class Dialogs {

  static init = (params) => {
    new Dialogs(params);
  }


  
  constructor(params) {
    this.allDialogs = document.querySelectorAll(params.selDialog);
    this.openingHandles = document.querySelectorAll(params.selOpeningHandle);
    this.closingHandles = document.querySelectorAll(params.selClosingHandle);

    this.openingHandles.forEach(this.initOpenHandles);
    this.closingHandles.forEach(this.initCloseHandles);
    this.allDialogs.forEach(this.initCloseDialogOnBackdropClick);
  }



  initOpenHandles = (openingHandle) => {
    const target = openingHandle.getAttribute('data-target');
    const targetDialog = document.getElementById(target);

    if (!targetDialog) {
      this.handleMissingDialog(target);
      return {};
    }

    openingHandle.addEventListener('click', () => {
      this.openDialog(targetDialog);
    })
  }



  initCloseHandles = (closingHandle) => {
    closingHandle.addEventListener('click', this.closeAllDialogs);
  }
  


  initCloseDialogOnBackdropClick = (dialog) => {
    dialog.addEventListener('click', this.closeDialogOnBackdropClick);
  }



  openDialog = (dialog) => {

    if (this.isModal(dialog)) {
      dialog.showModal();
      return;
    }

    dialog.show();
  }



  closeAllDialogs = () => {
    this.allDialogs.forEach((curDialog) => {
      curDialog.close();
    })
  }



  closeDialogOnBackdropClick = (event) => {
    const target = event.target;
    this.allDialogs.forEach((curDialog) => {
      if (target === curDialog) curDialog.close();
    })
  }



  isModal = (dialog) => dialog.dataset.type === 'modal';



  handleMissingDialog = (dialog) => {
    console.warn(`Missing dialog '${dialog}'! Initialisation failed!`);
  }
}